import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  hint?: string;
  className?: string;
}

export default function FormLabel({ children, hint, className }: Props) {
  return (
    <p className={className}>
      {children}
      {hint && (
        <>
          <br />
          <span className="text-xs font-normal">{hint}</span>
        </>
      )}
    </p>
  );
}
